/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { ArchiveResult, Pagination, Setter } from "../../utils/Interfaces";
import { Dispatch } from "react";
import { AnyAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { getHandler, stdErrHandlerFactory } from "../../utils/Requests";
import { setArchiveQuery, setArchiveResults } from "./archiveSlice";

export function listArchiveHandler(query: string, dispatch: Dispatch<AnyAction>, setLoading: Setter<boolean>) {
    getHandler(
        `/api/work-orders/archived?query=${query}`,
        dispatch,
        (response: AxiosResponse<Pagination<ArchiveResult>, any>) => {
            dispatch(setArchiveResults(response.data));
            dispatch(setArchiveQuery(query));
        },
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}
